import '@/i18n/template/projects/operation/views/Dashboard/CashOutMonitor/const.js'
import i18n from '@/i18n'
import store from '@/projects/operation/store'

export const AlertLvlCd = {
  Urgent: '3',
  Serious: '2',
  Normal: '1'
}

export const AlertLvlLevel_COLOR = {
  [AlertLvlCd.Urgent]: '#f56c6c',
  [AlertLvlCd.Serious]: '#e6a23c',
  [AlertLvlCd.Normal]: '#409eff'
}

export const AlertLvlOptions = [
  {
    getLabel: () => i18n.t('Urgent'),
    value: AlertLvlCd.Urgent,
    status: 'danger'
  },
  {
    getLabel: () => i18n.t('Serious'),
    value: AlertLvlCd.Serious,
    status: 'warning'
  },
  {
    getLabel: () => i18n.t('Normal'),
    value: AlertLvlCd.Normal,
    status: 'primary'
  }
]
export const AlertProcSts = {
  Unread: '0',
  Read: '1',
  Processed: '2'
}

export const AlertProcStsOptions = [
  {
    getLabel: () => i18n.t('Unread'),
    value: AlertProcSts.Unread,
    status: 'danger'
  },
  {
    getLabel: () => i18n.t('Read'),
    value: AlertProcSts.Read,
    status: 'primary'
  },
  {
    getLabel: () => i18n.t('Processed'),
    value: AlertProcSts.Processed,
    status: 'success'
  }
]

export const AlertRule = {
  MRCHNT_CASH_OUT_EQUAL_AMT_ALERT: 'MRCHNT_CASH_OUT_EQUAL_AMT_ALERT'
}
export const AlertRuleOptions = [
  {
    getLabel: () => i18n.t('ContinuousEqualCashoutAnomalyDetectTitle'),
    value: AlertRule.MRCHNT_CASH_OUT_EQUAL_AMT_ALERT
  }
]

export function getCashOutMonitorNotifyStorageKey() {
  const userId = store.state.user.userId
  const key = 'cashout_monitor_notify_switch_' + userId
  return key
}

export function getCashOutMonitorNotifyEnabled() {
  //无数据时 默认开启
  return localStorage.getItem(getCashOutMonitorNotifyStorageKey()) !== 'N'
}
